module.exports = __webpack_public_path__ + "static/ranger_wall-94ebcab2b458286c32221f83c3312e24.jpg";